import styled from 'styled-components';

const Navigation = styled.div`
  align-items: center;
  background: var(--color-bg-body);
  border-top: 1px solid var(--color-accent-secondary-weaker);
  display: flex;
  padding: 16px 24px;
  width: 100%;
  z-index: 1;
`;

const RightButtons = styled.div`
  align-items: center;
  display: flex;
  gap: 24px;
  justify-content: space-around;
  margin-left: auto;
`;

export { Navigation, RightButtons };
